/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { NOTES_CHARACTER_LIMIT } from "../../../../utility/constants";

const UpdateContactForm = ({
	loading,
	dispositions,
	subDispositions,
	disposition,
	subDisposition,
	notes,
	handleDispositionSelection,
	handleSubDispositionSelection,
	handleNotesChanges,
}) => {
	const enabledDispositions = dispositions.filter((disp) => disp?.isEnabled);
	const enabledSubDispositions = subDispositions.filter((disp) => disp?.isEnabled);
	return (
		<>
			<Grid className="d-flex align-items-center justify-content-between pt-4 px-3">
				<Grid item xs={5}>
					<Autocomplete
						disablePortal
						disabled={loading}
						id="dispositions"
						getOptionLabel={(option) => option.dispositionName}
						getOptionDisabled={(option) => !option.isEnabled}
						getOptionSelected={(option, value) => option.dispositionName === value.dispositionName}
						options={
							!disposition || disposition?.isEnabled ? enabledDispositions : [...enabledDispositions, disposition]
						}
						sx={{ width: 300 }}
						value={disposition}
						onChange={handleDispositionSelection}
						renderInput={(params) => <TextField {...params} label="Disposition" />}
					/>
				</Grid>
				<Grid item xs={5}>
					<Autocomplete
						disablePortal
						id="sub-dispositions"
						value={subDisposition}
						getOptionDisabled={(option) => !option.isEnabled}
						disabled={loading}
						getOptionLabel={(option) => option.subDispositionName}
						options={
							!subDisposition || subDisposition?.isEnabled
								? enabledSubDispositions
								: [...enabledSubDispositions, subDisposition]
						}
						onChange={handleSubDispositionSelection}
						sx={{ width: 300 }}
						renderInput={(params) => <TextField {...params} label="Sub-disposition" />}
					/>
				</Grid>
			</Grid>
			<Grid item xs={12} className="d-flex align-items-center justify-content-between pt-4 px-3">
				<TextField
					label="Notes"
					name="notes"
					type="text"
					fullWidth
					inputProps={{
						maxLength: NOTES_CHARACTER_LIMIT,
					}}
					multiline
					disabled={loading}
					helperText={`${notes.length}/${NOTES_CHARACTER_LIMIT}`}
					value={notes}
					rows={7}
					onChange={handleNotesChanges}
					margin="normal"
					variant="outlined"
				/>
			</Grid>
		</>
	);
};

export default UpdateContactForm;
